import HelpPoster from "./HelpPoster";
import { helpMedia } from "./helpMedia";
import { Announcement } from "./registry";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

interface AnnouncementDialogProps {
  announcement: Announcement;
  onPlay: () => void;
  onShowMe: () => void;
  onClose: () => void;
}

/** What's new: a title, a sentence or two, and the video's poster. */
const AnnouncementDialog = ({
  announcement,
  onPlay,
  onShowMe,
  onClose,
}: AnnouncementDialogProps) => {
  const media = announcement.video ? helpMedia(announcement.id) : null;
  const hasTour = (announcement.tour?.length ?? 0) > 0;
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{announcement.title}</DialogTitle>
      <DialogContent>
        <Stack spacing={4}>
          <Typography variant="body1" color="text.secondary">
            {announcement.body}
          </Typography>
          {media && (
            <HelpPoster
              media={media}
              title={announcement.title}
              onPlay={onPlay}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {hasTour && (
          <Button variant="contained" onClick={onShowMe}>
            Show me
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementDialog;
